import { Reveal } from "../components/Reveal";
import { INSTAGRAM, LOGO } from "../data/content";
import { Instagram, ExternalLink } from "lucide-react";

export const InstagramFeed = () => (
  <section data-testid="instagram-section" id="instagram" className="py-20 lg:py-32">
    <div className="container-blum">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
        <div>
          <Reveal>
            <p className="overline flex items-center gap-2">
              <Instagram className="w-4 h-4" /> Social Media
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
              Was es bei Blum Neues gibt, erfahren Sie auf Instagram
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-11 h-11 rounded-full bg-white border border-[#E5E0D8] flex items-center justify-center overflow-hidden shrink-0">
                <img src={LOGO} alt="Fussboden Blum" className="w-8 h-auto" />
              </span>
              <a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" className="font-display font-semibold text-[#2B2B30] hover:text-[#D32F2F] transition-colors">
                {INSTAGRAM.handle}
              </a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.12}>
          <a
            href={INSTAGRAM.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow"
            className="btn-base btn-red"
          >
            <Instagram className="w-4 h-4" /> Jetzt folgen
          </a>
        </Reveal>
      </div>

      {/* Live-Feed via Juicer.io (iFrame-Variante, übernimmt Dashboard-Vorgaben) */}
      <iframe
        src="https://www.juicer.io/api/feeds/fussbodenblum/iframe"
        data-testid="instagram-juicer"
        title="fussbodenblum - Juicer social media feed"
        frameBorder="0"
        style={{ display: "block", margin: "0 auto", width: "100%", maxWidth: "1000px", height: "1000px" }}
      />

      <Reveal delay={0.1}>
        <p className="text-center mt-10">
          <a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-display font-semibold text-lg text-[#2B2B30] hover:text-[#D32F2F] transition-colors">
            Mehr auf Instagram ansehen <ExternalLink className="w-4 h-4" />
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);
